import { configuration } from './configuration';
import { ProgramDetails, RestorativeProgram } from './types';

/**
 * NOTE: This is a very temporary fix. Ideally this will be handled via backend
 * TODO: Remove this as soon as possible
 */

export const getProgramConflicts = (programs: ProgramDetails[] | RestorativeProgram[]): boolean => {
  let activeProgram = false;
  let passiveProgram = false;

  programs.forEach((program) => {
    const programName: string = (program as ProgramDetails).title || (program as RestorativeProgram).name;

    if (programName === configuration.activeProgramName) {
      activeProgram = true;
    }

    if (programName === configuration.passiveProgramName) {
      passiveProgram = true;
    }
  });

  return activeProgram && passiveProgram;
};
